var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#0c82fd",
    height: "55px",
    width: "55px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7,16l-4.2-4.2c-0.4-0.4-1-0.4-1.4,0l-0.7,0.7c-0.8,0.8-2,0.8-2.8,0c-0.8-0.8-0.8-2,0-2.8l0.7-0.7c0.4-0.4,0.4-1,0-1.4 L16,3.3c-0.4-0.4-1-0.4-1.4,0l-2.8,2.8h0C11,5.3,10,4.9,8.9,4.9c-1.1,0-2.1,0.4-2.8,1.2S4.9,7.9,4.9,8.9c0,1.1,0.4,2.1,1.2,2.8l0,0 l-2.8,2.8c-0.4,0.4-0.4,1,0,1.4l4.2,4.2c0.4,0.4,1,0.4,1.4,0l0.7-0.7c0.8-0.8,2-0.8,2.8,0c0.8,0.8,0.8,2,0,2.8l-0.7,0.7 c-0.4,0.4-0.4,1,0,1.4l4.2,4.2c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l2.8-2.8h0c0.8,0.8,1.8,1.2,2.8,1.2c1.1,0,2.1-0.4,2.8-1.2 s1.2-1.8,1.2-2.8c0-1.1-0.4-2.1-1.2-2.8l0,0l2.8-2.8C29.1,17,29.1,16.4,28.7,16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.e464711fe3a2b24f20c36599b690b244.svg";
export { ForwardRef as ReactComponent };